import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl';
import { Form, Space, Button, InputNumber, Input, Checkbox } from 'antd';

const AddPulledServer = (props) => {  
    
    const intl = useIntl();
    const [form] = Form.useForm();

    const layout = {
        labelCol: {
            offset: 1,
            span: 3,
        },
        wrapperCol: {       
            offset: 0,
            span: 8,
        },
      };
      const tailLayout = {
        wrapperCol: {
          offset: 4,
          span: 6,
        },
      };
   
    function onFinish(values)
    {
        props.onSubmit({...values, "isPolled" : true});
    }

    function onFinishFailed(errorInfo)
    {
        
    }

    const onCancel = () => {
        props.onCancel();
    };

    return (
        <div style={{align:"left", textAlign: "left"}}>
            <Form form={form}
            {...layout}
            name="basic"
            initialValues={{
                serverName: props.data.serverName,
                serverURL: props.data.serverURL,
                pollingInterval: props.data.pollingInterval,
                extractJobData: props.data.extractJobData
            }}
            onFinish={(values) => onFinish(values)}
            onFinishFailed={(errorInfo) => onFinishFailed(errorInfo)}
            >
                <Form.Item
                    labelAlign="right"
                    label={intl.formatMessage({id: "ServerName"})}
                    name="serverName"
                    rules={[
                    {
                        required: true,
                        message: intl.formatMessage({id: "SMTP.server_name_empty"}),
                    },
                    ]}
                >
                    <Input disabled={props.data.name_readonly}/>
                </Form.Item>

                <Form.Item
                    labelAlign="right"
                    name="serverURL"
                    label={intl.formatMessage({id: "ServerURL"})}
                    rules={[
                    {
                        required: true,
                        message: intl.formatMessage({id : "ServerAddressEmpty"}),
                    },
                    ]}
                >
                    <Input/>
                </Form.Item>

                <Form.Item
                    labelAlign="right"
                    name="pollingInterval" 
                    label={intl.formatMessage({id : "PollingInterval"})}
                    rules={[
                        {
                            required: true,
                            message: intl.formatMessage({id : "ServerPollingIntervalEmpty"}),
                        }
                        ]}
                > 
                    <InputNumber min={10} max={36000}/>
                </Form.Item>

                <Form.Item {...tailLayout} name="extractJobData" valuePropName="checked">
                    <Checkbox><FormattedMessage id="ExtractJobData"/></Checkbox>
                </Form.Item>
                
                <Form.Item {...tailLayout} 
                    labelAlign="right">
                    <Space>
                    <Button type="default" htmlType="submit">
                        <FormattedMessage id="Submit"/>
                    </Button>
                    <Button type="default" htmlType="submit" onClick={onCancel}>
                        <FormattedMessage id="Cancel"/>
                    </Button>
                    </Space>
               </Form.Item>
            </Form>      
        </div>
    );   
    
};

export default AddPulledServer;